// extracted by css-extract-rspack-plugin
export default {"error":"mmVYk","desktop":"wj3TY","mobile":"XuRFw"};